import React, { useEffect } from "react";
import { formatEasternDisplayDate } from "../../../utils/dateUtils.ts";
import { buildAuthedFormBody } from "../../../utils/functions.ts";

const LittleBoxLog = ({ listId, listName, onClose }) => {
    // Allow ESC to close
    const [logEntries, setLogEntries] = React.useState([]);

    useEffect(() => {
        if (!listId) return;
        try {
            fetch('https://www.fbxchange.com/ReactPHP/listBox.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: buildAuthedFormBody({
                    method: 'getTheLog',
                    listID: listId
                }).toString()
            })
            .then(response => response.json())
            .then(data => {
                if (Array.isArray(data)) {
                    setLogEntries(data);
                } else {
                    setLogEntries([]);
                }
            })
            .catch(error => {
                console.error('Request failed:', error);
                setLogEntries([]);
            });
        } catch (error) {
            console.error('Unexpected error:', error);
            setLogEntries([]);
        }
    }, [listId]);


    useEffect(() => {
        const onKey = (e) => (e.key === "Escape" ? onClose?.() : null);
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);

    const handleRemoveLog = (logId) => {
        if (!logId || !listId) return;
        try {
            fetch('https://www.fbxchange.com/ReactPHP/listBox.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: buildAuthedFormBody({
                    method: 'removeLogEntry',
                    logID: logId,
                    listID: listId
                }).toString()
            })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                // Assume data is the new log array
                if (Array.isArray(data)) {
                    setLogEntries(data);
                } else {
                    console.error('Unexpected response:', data);
                }
            })
            .catch(error => {
                console.error('Request failed:', error);
            });
        } catch (error) {
            console.error('Unexpected error:', error);
        }
    }

    return (
        <div className="littlebox-log-container" style={{ width: "100%" }}>
            <h5 className="mb-3"><span className="text-primary">{listName}</span></h5>
            <table className="table table-sm">
                <thead>
                    <tr>
                        <th className="col-8 text-center">Date</th>
                        <th className="col-24 text-start">Action</th>
                        <th className="col-6 text-center">By Who</th>
                        <th className="col-6 text-center">Remove</th>
                    </tr>
                </thead>
                <tbody>
                    {logEntries.length === 0 ? (
                        <tr>
                            <td colSpan={4} className="text-center text-muted">
                                (No log entries yet)
                            </td>
                        </tr>
                    ) : (
                        logEntries.map((entry, idx) => (
                            <tr key={idx}>
                                <td className="text-center">
                                    {entry.whenAdded
                                        ? formatEasternDisplayDate(entry.whenAdded)
                                        : ""}
                                </td>
                                <td className={`text-start${entry.byWho !== 'You' ? ' fw-bold text-danger' : ''}`}>
                                    {entry.Action}
                                </td>
                                <td className={`text-center${entry.byWho !== 'You' ? ' fw-bold text-danger' : ''}`}>
                                    {entry.byWho}
                                </td>
                                <td className="text-center">
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleRemoveLog(entry.ID)}>Remove</button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default LittleBoxLog;
